import React from 'react';
import { X } from 'lucide-react';
export function Problem() {
  return <section className="bg-white text-navy py-12" data-id="element-187">
      <div className="max-w-md mx-auto px-4" data-id="element-188">
        <h2 className="text-2xl font-bold text-violet text-center mb-4" data-id="element-189">
          ¿Cuántos actos más vas a armar a las apuradas?
        </h2>
        <p className="text-center text-gray-700 mb-8 font-medium" data-id="element-190">
          Sin un sistema claro, siempre termina igual.
        </p>

        <ul className="space-y-4 mb-8" data-id="element-191">
          {['Buscás partitura por partitura en internet, y ninguna te cierra del todo', 'Armás el repertorio del acto la noche anterior', 'Repetís siempre las mismas canciones porque no tenés tiempo de variar', 'Un alumno o directivo pide algo puntual y no tenés nada preparado', 'El acto se siente desordenado y vos lo notás primero que nadie', 'Empezás el año con ganas, te agotás organizando, y en marzo del año siguiente es lo mismo'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-[15px] text-gray-700" data-id="element-192">
              <X className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-193" />
              <span data-id="element-194">{item}</span>
            </li>)}
        </ul>

        <div className="bg-turquoise text-white p-6 rounded-2xl text-center shadow-lg" data-id="element-195">
          <p className="font-bold text-lg mb-2" data-id="element-196">No es falta de vocación.</p>
          <p className="font-bold text-lg mb-4" data-id="element-197">Es falta de un sistema.</p>
          <p className="text-sm opacity-90" data-id="element-198">
            Con Flauta Master Class, tu próxima clase ya está armada. 🎵
          </p>
        </div>
      </div>
    </section>;
}